import { render } from "./WaitDisable2FA.vue?vue&type=template&id=34739b3c"
import script from "./WaitDisable2FA.vue?vue&type=script&lang=js"
export * from "./WaitDisable2FA.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__